import React from "react"
import styled from "styled-components"
import { Headline, animationProperties } from "../../../utils"
import { AosWrapper } from "../../molecules/AosWrapper"
import useDeviceTheme from "@project/shared/src/useDeviceTheme"

const Wrapper = styled.div`
  padding: 100px 20px 0 20px;
  background: ${(props) => props.theme.bgSectorColor};
  @media (max-width: 768px) {
    padding: 38px;
  }
  border-top: 1px solid #1e2538;

  @media (max-width: 641px) {
    padding: 50px 20px;
  }
`
const HeadlineText = styled(Headline)`
  position: relative;
  margin-bottom: 0;
  color: ${(props) => props.theme.base};
  font-weight: 600;
  font-size: 24px;
  line-height: 150%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;

  @media (max-width: 1023px) {
    font-size: 1.125rem !important;
    white-space: normal !important;
  }

  .open-vector,
  .close-vector {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    object-fit: contain;
  }

  .open-vector {
    width: 64px;
    height: auto;
    margin-right: 12px;
    top: -6px;

    @media (max-width: 768px) {
      width: 48px;
      margin-right: 8px;
      top: -4px;
    }

    @media (max-width: 641px) {
      width: 40px;
      margin-right: -6px;
      top: -15px;
    }
  }

  .close-vector {
    width: 64px;
    height: auto;
    margin-left: 12px;
    top: 10px;

    @media (max-width: 768px) {
      width: 48px;
      margin-left: 8px;
      top: 6px;
    }

    @media (max-width: 641px) {
      width: 40px;
      margin-left: 6px;
      top: 4px;
    }
  }
`

const ImageWrapper = styled.div`
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -85px;
  @media (max-width: 768px) {
    margin-top: -30px;
  }

  .mobile-img {
    display: none;
  }

  .mobile-img,
  .desktop-img {
    object-fit: contain;
    margin-top: -120px;
    width: 1450px;
    @media (max-width: 1500px) {
      width: 100%;
    }
    @media (max-width: 768px) {
      margin-top: -60px;
    }
    @media (max-width: 641px) {
      width: calc(100% + 80px);
      margin-top: 6px;
    }
  }
`

export const GradientTitle = styled.span`
  ${(props) => props.theme.typography.sectionHeadline};
  background: ${(props) => props.theme.indicatorGradient};
  background-clip: text;
  text-transform: capitalize;
  /* stylelint-disable property-no-vendor-prefix */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 600;
  font-size: 24px;
  line-height: 150%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;

  @media (max-width: 1023px) {
    font-size: 1.125rem;
  }
`

const CompanyEfficiency: React.FC = () => {
  const isDarkTheme = useDeviceTheme()
  return (
    <Wrapper>
      <AosWrapper>
        <HeadlineText>
          <img className={"open-vector"} src={"/assets/imgs/open-vector.svg"} />

          {"We aim to empower individuals and businesses\n"}
          <GradientTitle> {"productivity "}</GradientTitle>
          {"and"}
          <GradientTitle> {"efficiency "}</GradientTitle>
          {"through our "}
          <GradientTitle>{"software solutions."}</GradientTitle>
          <img
            className={"close-vector"}
            src={"/assets/imgs/close-vector.svg"}
          />
        </HeadlineText>
        <AosWrapper
          duration={animationProperties.duration + 0.2}
          delay={animationProperties.delay + 0.2}
          animateIn={"animate__fadeInUpBig animate__zoomIn"}
        >
          <ImageWrapper>
            <img
              className={"desktop-img"}
              src={
                isDarkTheme
                  ? "/assets/imgs/our-team.png"
                  : "/assets/imgs/our-team.svg"
              }
              width={"100%"}
              height={"auto"}
            />
          </ImageWrapper>
        </AosWrapper>
      </AosWrapper>
    </Wrapper>
  )
}

export { CompanyEfficiency }
